import React, { useEffect, useState } from "react";
import moment from "moment";
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import { Input, Button, Row, Col, Card, CardBody, FormGroup, Form } from "reactstrap";

// helpers
import { formateDateandTimeApi, formateMonthName } from "../../../helpers/formats.js";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_PUT } from "../../../services/api_service.js";

//Context
import { useAuth } from "../../../context/auth";

export default function AgendamentoVistoria({ requerimentoAgendamento, handleReturn }) {
    const { session, setLoading } = useAuth();

    const { handleSubmit } = useForm({ mode: "onBlur" });


    const [list_agendamentos, set_list_agendamentos] = useState([]);

    const loadListAgendamentos = () => {
        setLoading(true);
        api_GET(`AgendamentoVistoria/GetAgendamentoVistoriaByRequerimento/${requerimentoAgendamento.requerimento_Id}`)
            .then(result => set_list_agendamentos(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleChangeDataHoraAgendamento = (requerimentoTransportadorAgendamento_Id, value) => {
        if (list_agendamentos.filter(f => f.requerimentoTransportadorAgendamento_Id != requerimentoTransportadorAgendamento_Id
            && f.dataHora == value && f.dataHora != null).length > 0) {
            value = null;
            showMessage("Aviso", "Você já agendou outro veículo neste horário!", 'error', null);
        }

        let _newlist = [];
        list_agendamentos.map(m => {
            if (m.requerimentoTransportadorAgendamento_Id == requerimentoTransportadorAgendamento_Id) {
                m.dataHora = value;

                if (value)
                    m.situacao = "Agendado";
                else
                    m.situacao = "Pendente";
            }
            _newlist.push(m);
        });
        set_list_agendamentos(_newlist);
    }

    const handleClickRemoverVeiculo = (requerimentoTransportadorAgendamento_Id) => {
        showQuestion("Confirma o cancelamento do agendamento do veículo?", "Este veículo não poderá mais ser agendado para vistoria.", 'question', function (retorno) {
            if (retorno) {
                let _newlist = [];
                list_agendamentos.map(m => {
                    if (m.requerimentoTransportadorAgendamento_Id == requerimentoTransportadorAgendamento_Id) {
                        m.situacao = "Cancelado";
                        m.dataHora = null;
                    }
                    _newlist.push(m);
                });
                set_list_agendamentos(_newlist);
            }
        });
    }

    useEffect(() => {
        loadListAgendamentos();
    }, [requerimentoAgendamento]);

    const onSubmit = (data) => {
        if (list_agendamentos.filter(f => f.dataHora == null && f.situacao != "Cancelado").length > 0) {
            showMessage("Aviso", "É necessário criar o agendamento de todos os veículos!", 'error', null);
            return;
        }

        let json_submit = []
        list_agendamentos.map(m => {
            json_submit.push({
                requerimentoTransportadorAgendamento_Id: m.requerimentoTransportadorAgendamento_Id,
                requerimentoTransportadorVeiculo_Id: m.requerimentoTransportadorVeiculo_Id,
                dataHora: m.dataHora,
                situacao: m.situacao,
                logAgendamento: session != null && session.tipoAcesso == "AreaRestrita" ? `Atualizado pelo usuário ${session.nome} (${session.usuario_Id})` : "Atualizado pelo Transportador"
            })
        })

        setLoading(true);
        api_PUT(`AgendamentoVistoria/PutRequerimentoTransportadorAgendamento`, json_submit)
            .then(result => {
                setLoading(false);
                showMessage("Aviso", "Agendamento atualizado com sucesso", 'success', function () {
                    if (handleReturn)
                        handleReturn();
                });
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        {handleReturn && <Button type="button" color="Primary" onClick={handleReturn}><i className="fas fa-chevron-left"></i>  Voltar</Button>}
                        <Card className="card-user">
                            <CardBody style={{ minHeight: "auto" }}>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col lg="12" sm="12">
                                            <p><b>{requerimentoAgendamento && requerimentoAgendamento.categoria_Descricao}</b></p>
                                        </Col>
                                        <Col lg="4" sm="12">
                                            <p><b>CPF/CNPJ:</b> {requerimentoAgendamento && requerimentoAgendamento.cpf_Cnpj}</p>
                                        </Col>
                                        <Col lg="4" sm="12">
                                            <p><b>Nome/Fantasia:</b> {requerimentoAgendamento && requerimentoAgendamento.nome_Fantasia}</p>
                                        </Col>
                                        <Col lg="4" sm="12">
                                            <p><b>Tipo Requerimento:</b> {requerimentoAgendamento && requerimentoAgendamento.tipoRequerimento}</p>
                                        </Col>
                                    </Row>
                                    {list_agendamentos.map((m, key) => {
                                        return <ItemAgendaVistoria key={key} item={m} setLoading={setLoading} handleChangeDataHoraAgendamento={handleChangeDataHoraAgendamento} handleClickRemoverVeiculo={handleClickRemoverVeiculo}></ItemAgendaVistoria>
                                    })}
                                    <Row>
                                        <Col className="text-center" md="12" sm="12">
                                            <FormGroup>
                                                <Button color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

function ItemAgendaVistoria({ item, handleChangeDataHoraAgendamento, setLoading, handleClickRemoverVeiculo }) {
    // Ano (ano atual + próximo ano)
    const options_ano = [
        { value: moment(new Date()).format('YYYY'), label: moment(new Date()).format('YYYY') },
        { value: moment(new Date()).add(1, 'years').format('YYYY'), label: moment(new Date()).add(1, 'years').format('YYYY') }
    ];
    const [ano, set_ano] = useState(moment(new Date()).format('YYYY'));
    const handleAno = (value) => {
        set_ano(value);
        loadOptionsMes(value);
    }

    // Mês
    const [options_mes, set_options_mes] = useState([]);
    const loadOptionsMes = (_ano) => {
        let _meses = [];
        let _mes = 1
        if (_ano == moment(new Date()).format('YYYY'))
            _mes = parseInt(moment(new Date()).format('MM'));

        do {
            _meses.push({ value: _mes, label: formateMonthName(_mes) });
            _mes++;
        } while (12 >= _mes);
        set_options_mes(_meses)
    }
    const [mes, set_mes] = useState(moment(new Date()).format('MM'));
    const handleMes = (value) => {
        set_mes(value);
        set_diaAgendamento(null);
        set_horario(null);
        handleChangeDataHoraAgendamento(item.requerimentoTransportadorAgendamento_Id, null);
        loadOptionsDisponibilidadeAgenda(value);
    }

    // Disponibilidade Agenda
    const [options_disponibilidadeAgenda, set_options_disponibilidadeAgenda] = useState([]);
    const loadOptionsDisponibilidadeAgenda = (_mes, _dia) => {
        setLoading(true);
        api_GET(`AgendamentoVistoria/GetDisponibilidadeAgenda/${item.requerimentoTransportadorAgendamento_Id}/${ano}/${_mes}`)
            .then(result => {
                set_options_disponibilidadeAgenda(result.data);
                if (_dia && result.data.filter(f => f.dia == _dia).length > 0)
                    set_options_horario(result.data.filter(f => f.dia == _dia)[0].horarios);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const [diaAgendamento, set_diaAgendamento] = useState(null);
    const handleDiaAgendamento = (value) => {
        set_diaAgendamento(value);
        set_options_horario(options_disponibilidadeAgenda.filter(f => f.dia == value)[0].horarios);
        set_horario(null);
        handleChangeDataHoraAgendamento(item.requerimentoTransportadorAgendamento_Id, null);
    }

    // Horarios disponiveis
    const [options_horario, set_options_horario] = useState([]);
    const [horario, set_horario] = useState(null);
    const handleHorario = (value) => {
        set_horario(value);
        let datahora = formateDateandTimeApi(new Date(ano, mes - 1, diaAgendamento, parseInt(value.split(':')[0]), parseInt(value.split(':')[1])));
        handleChangeDataHoraAgendamento(item.requerimentoTransportadorAgendamento_Id, datahora);
    }

    const loadDefaultValues = () => {
        set_ano(moment(item.dataHora).format('YYYY'));
        loadOptionsMes(moment(item.dataHora).format('YYYY'));
        set_mes(parseInt(moment(item.dataHora).format('MM')));
        set_diaAgendamento(parseInt(moment(item.dataHora).format('DD')));
        loadOptionsDisponibilidadeAgenda(parseInt(moment(item.dataHora).format('MM')), parseInt(moment(item.dataHora).format('DD')));
        set_horario(moment(item.dataHora).format('HH:mm'));
    }

    useEffect(() => {
        if (item.dataHora) {
            loadDefaultValues();
        }
        else {
            loadOptionsMes(moment(new Date()).format('YYYY'));
        }
    }, [item]);

    return (
        <>
            <Row>
                <Col lg="2" md="2" sm="4">
                    <FormGroup>
                        <b><label>Placa</label></b>
                        <Input type="text" name="placa" defaultValue={item.placa} readonly="readonly" />
                    </FormGroup>
                </Col>
                <Col lg="2" md="2" sm="4">
                    <FormGroup>
                        <b><label>Situação</label></b>
                        <Input type="text" name="situacao" value={item.situacao} readonly="readonly" />
                    </FormGroup>
                </Col>
                {item.situacao == "Agendado" &&
                    <Col lg="4" md="4" sm="4">
                        <br />
                        <Button className="btn-link btn-info" type="button" onClick={() => handleClickRemoverVeiculo(item.requerimentoTransportadorAgendamento_Id)}> Remover Veículo</Button>
                    </Col>
                }
            </Row>
            <Row>
                <Col lg="2" md="2" sm="3">
                    <FormGroup>
                        <b><label><span className="text-danger">*</span> Ano</label></b>
                        <Select
                            options={options_ano}
                            name="ano"
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ value }) => value}
                            onChange={(e) => { handleAno(e.value) }}
                            value={options_ano.find(obj => obj.value === ano)}
                            isDisabled={(item.situacao == "Executado" || item.situacao == "Cancelado") ? true : false}
                        />
                    </FormGroup>
                </Col>
                <Col lg="2" md="2" sm="3">
                    <FormGroup>
                        <b><label><span className="text-danger">*</span> Mês</label></b>
                        <Select
                            options={options_mes}
                            name="mes"
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ value }) => value}
                            onChange={(e) => { handleMes(e.value) }}
                            value={options_mes.find(obj => obj.value === mes)}
                            placeholder="Selecione"
                            isDisabled={(item.situacao == "Executado" || item.situacao == "Cancelado") ? true : false}
                        />
                    </FormGroup>
                </Col>
                <Col lg="2" md="2" sm="3">
                    <FormGroup>
                        <b><label><span className="text-danger">*</span> Dia</label></b>
                        <Select
                            options={options_disponibilidadeAgenda}
                            name="dia"
                            getOptionLabel={({ dia }) => dia}
                            getOptionValue={({ dia }) => dia}
                            onChange={(e) => { handleDiaAgendamento(e.dia) }}
                            value={options_disponibilidadeAgenda.find(obj => obj.dia === diaAgendamento)}
                            placeholder="Selecione"
                            isDisabled={(item.situacao == "Executado" || item.situacao == "Cancelado") ? true : false}
                        />
                    </FormGroup>
                </Col>
                <Col lg="2" md="3" sm="3">
                    <FormGroup>
                        <b><label><span className="text-danger">*</span> Horário</label></b>
                        <Select
                            options={options_horario}
                            getOptionLabel={(f) => f}
                            getOptionValue={(f) => f}
                            name="horario"
                            onChange={(e) => { handleHorario(e) }}
                            value={options_horario.filter(obj => obj == horario)}
                            placeholder="Selecione"
                            isDisabled={(item.situacao == "Executado" || item.situacao == "Cancelado") ? true : false}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <hr />
        </>
    )
}